<template>
	<div id="app">
		<div class='fview' @click.stop="hideView(true)" :class='{trans:isMove}'>
			<div class="float_div" @click.stop="hideView(false)" @mouseleave="hideView(true)">
				<div class="content">
					<div class="content1">
						<template v-for="(item,index) in menu">
							<template v-if="index==0">
								<div class="top">
									<img src="./assets/menu_title.png" />
									<span>{{item.title}}</span>
								</div>
								<template v-for="item1 in item.children">
									<div class="title1">{{item1.title}}</div>
									<div @click.stop="goDetail(item2.img)" class="title2"
										v-for="item2 in item1.children[1].list">{{item2.title}}</div>
								</template>
							</template>
							<template v-if="index==1||index==2">
								<div class="top">
									<img src="./assets/menu_title.png" />
									<span>{{item.title}}</span>
								</div>
								<div class="title2" v-for="item1 in item.children" @click.stop="goDetail(item1.img)">
									{{item1.title}}
								</div>
							</template>

						</template>

						<div class="top">
							<img src="./assets/menu_title.png" />
							<span>其他类</span>
						</div>
						<div class="title2" v-for="ite in menu1" @click.stop="goDetail(ite.list[0].img)">
							{{ite.title}}
						</div>

					</div>
				</div>
			</div>
		</div>

		<div id="nav">
			<div class="top-bar">
				<img class="im" src="./assets/logo.png" @click="goToNewPage(100)" />
				<div class="con">
					<ul>
						<li v-for="(item,index) in navData" @click="goToNewPage(index)" :key="index"
							@mouseenter="showView(index)">
							{{item}}
						</li>
					</ul>
				</div>
			</div>
		</div>
		<div style="height: 3vw;"></div>
		<router-view :key="key"></router-view>
		<div class="footer">
			<div class="content">
				<div class="title">{{entry}}</div>
				<ul>
					<li v-for="(item,index) in navData1" @click="goToNewPage(index+100)" :key="index">
						{{item}}
					</li>
				</ul>
				<div class="title">{{contact}}</div>
				<div class="c1">
					<img src="./assets/1-7.png" />
					<span>{{phone}}</span>
				</div>
				<div class="c1">
					<img src="./assets/1-8.png" />
					<span>{{address}}</span>
				</div>
				<img src="./assets/1-6.jpg" />
				<div style="display: flex;justify-content: center;color: white;margin-top: 40px;font-size: 12px;">
					版权所有·北京赢科天地电子有限公司&nbsp;&nbsp;<a style="color:white;" href="https://beian.miit.gov.cn"
						target="_blank">京ICP备11008321号-1</a></span></div>
			</div>
		</div>

	</div>
</template>

<script>
	export default {
		data() {
			return {
				isMove: false,
				floatShow: false,
				entry: '快捷入口',
				contact: '联系我们',
				phone: '010-82887279',
				address: '北京市海淀区花园东路31号牡丹宾馆办公区4号楼5层501',
				navData: ['关于我们', '产品中心', '咨询与服务', '招贤纳士', '联系我们'],
				navData1: ['首页', '公司简介', '业务体系', '新闻中心', '联系我们', '诚聘英才', 'OA 系统', '企业邮箱'],
				menu: [
					{
						title: '软件系统',
						children: [{
							title: '智慧校园平台',
							children: [
								{ title: '平台功能', list: [] },
								{ title: '核心产品', list: [{ title: '数字校园基础平台', img: '' }, { title: '统一身份认证', img: '' }, { title: '数据共享与治理', img: '' }, { title: '一站式服务门户', img: '' }] },
							],
						},
						{
							title: '教务管理系统',
							children: [
								{ title: '平台功能', list: [] },
								{ title: '核心产品', list: [{ title: '学籍管理', img: '' }, { title: '智能排课', img: '' }, { title: '选课管理', img: '' }, { title: '成绩管理', img: '' }] },
							],
						},
						{
							title: '学生工作管理',
							children: [
								{ title: '平台功能', list: [] },
								{ title: '核心产品', list: [{ title: '迎新离校管理', img: '' }, { title: '资助管理', img: '' }, { title: '心理健康', img: '' }] },
							],
						},
						],
					},
					{
						title: '内容资源',
						children: [{ title: '精品课程资源', img: '' }, { title: '数字教材', img: '' }, { title: '虚拟仿真资源', img: '' }],
					},
					{
						title: '设备环境',
						children: [{ title: '智慧教室', img: '' }, { title: '实验室环境', img: '' }, { title: '网络中心机房', img: '' }],
					},
				],
				menu1: [
					{ title: '行业解决方案', list: [{ img: '' }] },
					{ title: '定制开发服务', list: [{ img: '' }] },
					{ title: '系统集成服务', list: [{ img: '' }] },
				],
			}
		},
		computed: {
			key() {
				return this.$route.name !== undefined ?
					this.$route.name + new Date() :
					this.$route + new Date()
			},
		},

		methods: {
			goToNewPage(index) {
				if (index == 106) {
					window.open('http://cas.incons.com.cn:7001/incon/login.jsp')
					return;
				}
				if (index == 107) {
					window.open('https://exmail.qq.com/login')
					return;
				}
				let path = ''
				switch (index) {
					case 0:
					case 101:
						path = '/about'
						break;
					case 103:
						path = '/about?type=1'
						break
					case 1:
					case 102:
						path = '/productcenter'
						break
					case 2:
						path = '/consultingservices'
						break
					case 3:
					case 105:
						path = '/jobindex'
						break
					case 4:
					case 104:
						path = '/contactus'
						break
					case 100:
						path = '/home'
						break
					case 108:
						path = '/register'
						break
				}
				if (path) this.$router.push(path)
				this.isMove = false
			},
			showView(index) {
				// if (index == 1) this.isMove = true
			},
			hideView(show) {
				this.isMove = !show
			},
			goDetail(item) {
				if (item) {
					window.open(item)
					this.isMove = false
				}
			},
		},
		mounted() {
			var url =
				this.HOST +
				'wzPage/getJson?id=D939090B87EE124BE05509994F3826F5&moduleOrder=ordernum&contentOrder=ordernum&websiteid=4'
			this.$axios.get(url).then((res) => {
				window.localStorage.setItem('products', JSON.stringify(res.data))
				// console.log(JSON.parse(window.localStorage.getItem("products")))
				this.menu = res.data.content[0].children[0].children[1].children
				this.menu1 = res.data.content[0].children[0].children[0].children
			})
		},
	}
</script>

<style lang="less">
	.trans {
		transform: translateY(200vh);
	}

	#app {
		.fview {
			width: 100vw;
			height: 100vh;
			position: fixed;
			margin-top: 10px;
			z-index: 1000;
			top: -200vh;
			transition: transform 700ms ease-out;
		}

		#nav {
			.top-bar {
				z-index: 1000;
				position: fixed;
				width: 100%;
				background-color: #3a3632;
				height: 3vw;
				display: flex;
				padding-left: 6vw;
				align-items: center;
				min-height: 40px;
				min-width: 1000px;
				justify-content: center;

				.im {
					width: 7.5vw;
					height: 2.5vw;
					cursor: pointer;
					min-width: 60px;
					min-height: 20px;
					position: absolute;
					left: 100px;
				}

				.con {
					// 	display: flex;
					// 	flex-grow: 1;
					// 	justify-content: center;
					margin-left: -9vw;
				}

				ul {
					list-style: none;
					color: #ffffff;
				}

				li {
					float: left;
					margin-left: 3vw;
					line-height: 3vw;
					font-size: 1.1vw;
					line-height: 3vw;
					cursor: pointer;
				}

				ul li img {
					width: 2.8vw;
					height: 2.8vw;
					vertical-align: middle;
				}

				li:hover {
					color: dodgerblue;
					// border-bottom: 1px solid #1E90FF;
				}

				.selectColor {
					color: dodgerblue;
				}
			}
		}

		.footer {
			width: 100%;
			background-color: #3a3632;
			// height: 18vw;
			min-width: 1200px;
			padding-bottom: 10px;

			.content {
				width: 75vw;
				min-width: 1000px;
				margin: auto;
				position: relative;

				.title {
					font-size: 1vw;
					line-height: 1vw;
					color: #fff;
					padding: 1.5vw;
					clear: both;
				}

				ul {
					list-style: none;
					margin-bottom: 30px;
				}

				li {
					font-size: 1vw;
					line-height: 1vw;
					color: #fff;
					margin-left: 30px;
					float: left;
				}

				li:hover {
					color: dodgerblue;
					cursor: pointer;
				}

				.c1 {
					margin-left: 20px;
					margin-bottom: 10px;

					img {
						vertical-align: middle;
						position: static;
						width: 20px;
						height: 20px;
					}

					span {
						font-size: 1vw;
						line-height: 1vw;
						color: #fff;
						margin-left: 10px;
					}
				}

				img {
					width: 5vw;
					height: 5vw;
					position: absolute;
					bottom: 70px;
					right: 20px;
				}
			}
		}

		.float_div {
			width: 100%;
			background-color: #00000099;
			// position: fixed;
			// top: 0px;
			// z-index: 1001;
			color: #ffffff;

			.content {
				width: 70%;
				margin: auto;
				display: flex;
				padding-top: 50px;
				padding-bottom: 30px;

				.top {
					margin-top: 5px;
					border-bottom: 2px solid #ffffff33;
					width: 80%;

					img {
						vertical-align: middle;
						width: 40px;
						height: 40px;
					}
				}

				.left_title {
					width: 20%;

					span {
						font-size: 14px;
						line-height: 100px;
					}
				}

				.content1 {
					height: 300px;
					display: flex;
					flex-direction: column;
					flex-wrap: wrap;

					span {
						margin-left: 10px;
					}
				}

				.title1 {
					font-size: 13px;
					font-weight: 550;
					line-height: 30px;
					width: 280px;
					margin-right: 10px;
				}

				.title2 {
					font-size: 13px;
					width: 280px;
					line-height: 24px;
				}

				.title2:hover {
					color: dodgerblue;
					cursor: pointer;
				}
			}
		}
	}

	.ivu-menu-vertical .ivu-menu-item,
	.ivu-menu-vertical .ivu-menu-submenu-title {
		padding: 4px 14px;
		font-weight: 600;
		font-size: 15px;
	}
</style>